import { Component, EventEmitter, Input, Output, afterRender } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { LayerList, LayerType } from '../models/layer.model';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { MoveLayerDirection } from '../models/properties.model';


@Component({
  selector: 'app-layer-list',
  standalone: true,
  imports: [
    FormsModule,
    CheckboxModule,
    ButtonModule,
    RippleModule
  ],
  templateUrl: './layer-list.component.html',
  styleUrl: './layer-list.component.scss'
})
export class LayerListComponent {
  @Input() set selectedLayerId(value:  string | undefined | null){
    this._selectedLayerId = value
    this.computeCheckBoxesSelected(value)
  }
  get selectedLayerId(){
    return this._selectedLayerId
  }

  @Input() set layers (value: LayerList | null){
    if (value){
      this._layers = value
    }
  }
  get layers(): LayerList{
    return this._layers
  }
  private _layers: LayerList = {}

  @Input() layerOrder: string[] | null = []

  @Output() setSelectedLayer = new EventEmitter<string | undefined>()
  @Output() toggleShowEffects = new EventEmitter<string>()
  @Output() deleteLayer = new EventEmitter<string>()
  @Output() toggleLayerVisibility = new EventEmitter<string>()
  @Output() cloneLayer = new EventEmitter<string>()
  @Output() changeLayerOrder = new EventEmitter<{id: string, index: number}>()
  @Output() deleteEffect = new EventEmitter<{layerId: string, effectId: string}>()
  @Output() selectEffect = new EventEmitter<string>()
  @Output() moveLayer = new EventEmitter<{
    direction: MoveLayerDirection,
    layerId: string
  }>()
  @Output() moveEffect = new EventEmitter<{
    direction: MoveLayerDirection,
    effectId: string,
    layerId: string
  }>()

  private _selectedLayerId: string | undefined | null
  moveDirections = MoveLayerDirection

  layerTypes = LayerType

  checkboxSelected: {[key: string]: boolean} = {}
  currentlyDragging: string

  computeCheckBoxesSelected(selectedLayerId: string | null | undefined) {
    Object.keys(this.checkboxSelected).forEach(key => this.checkboxSelected[key] = false)
    if (!selectedLayerId) {
      return
    }
    this.checkboxSelected[selectedLayerId] = true
  }

  selectLayer(id: string){
    let selectedLayerId: string | undefined
    if (this.selectedLayerId === id) {
      selectedLayerId = undefined
    }
    else {
      selectedLayerId = id
    }
    this.setSelectedLayer.emit(selectedLayerId)
  }

  layerDivClicked(layerId: string, div: HTMLDivElement, event: MouseEvent) {
    const buttonGrouping = div.querySelector<HTMLDivElement>("#buttons")
    const checkbox = div.querySelector<HTMLDivElement>("#checkbox")
    if ((event.target as Element).className.includes("button")){
      return
    }
    if (!buttonGrouping || !event.target) {
      return
    }
    if (buttonGrouping.contains(event.target as Node)) {
      return
    }
    this.selectLayer(layerId)
  }
}
